/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listCustomerKnownNumbersParamsCursorMax = 512;

export const listCustomerKnownNumbersParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listCustomerKnownNumbersParamsLimitDefault = 50;
export const listCustomerKnownNumbersParamsLimitMax = 100;

export const ListCustomerKnownNumbersParams = zod.object({
  cursor: zod
    .string()
    .min(1)
    .max(listCustomerKnownNumbersParamsCursorMax)
    .regex(listCustomerKnownNumbersParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listCustomerKnownNumbersParamsLimitMax)
    .default(listCustomerKnownNumbersParamsLimitDefault),
});

export type ListCustomerKnownNumbersParams = zod.input<typeof ListCustomerKnownNumbersParams>;
export type ListCustomerKnownNumbersParamsOutput = zod.output<
  typeof ListCustomerKnownNumbersParams
>;
